import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useInboxCounts } from './InboxCountsContext';
import SongRequestList from './SongRequestList';
import ContactRequestList from './ContactRequestList';
import './RequestsPanel.css';

// DJB-264: the status filter is a segmented control top-right — To Do (open,
// with its count), Completed (handled) and All. To Do is the default.
export const FILTERS = [
  { key: 'open', label: 'To Do' },
  { key: 'handled', label: 'Completed' },
  { key: 'all', label: 'All' },
];

// DJB-279: the inbox pages carry a segmented switch between the two kinds
// top-left, each with its to-do badge; it links to the kind's own route
export const KIND_SWITCH = [
  { key: 'contact', label: 'Contact Requests', path: '/inbox/contact', badge: 'contactOpen' },
  { key: 'songs', label: 'Song Requests', path: '/inbox/songs', badge: 'songsOpen' },
];

const COUNT_KEY = { contact: 'contactOpen', songs: 'songsOpen' };

// The filter + list for one request kind. Mounted on the inbox pages (with
// the kind switch) and, for songs, as the Song Requests section under
// Library › Upload (DJB-269, without it) — one component, two places, so
// both behave identically and share the badges.
const RequestsPanel = ({ kind = 'contact', today, showKindSwitch = false }) => {
  const { counts, refreshCounts } = useInboxCounts();
  const [status, setStatus] = useState('open');

  // Fresh badge counts whenever the panel mounts
  useEffect(() => {
    refreshCounts();
  }, [refreshCounts]);

  const todo = counts[COUNT_KEY[kind]] || 0;

  return (
    <div className="requests-panel" data-kind={kind}>
      <div className="inbox-toolbar">
        {showKindSwitch && (
          <nav className="inbox-segmented inbox-kind-switch" aria-label="Request kind">
            {KIND_SWITCH.map((k) => {
              const active = kind === k.key;
              const count = counts[k.badge] || 0;
              return (
                <Link
                  key={k.key}
                  to={k.path}
                  className={`inbox-segment${active ? ' is-active' : ''}`}
                  aria-current={active ? 'page' : undefined}
                >
                  {k.label}
                  {count > 0 && <span className="inbox-segment-count">{count}</span>}
                </Link>
              );
            })}
          </nav>
        )}
        <div className="inbox-segmented inbox-filter" role="group" aria-label="Filter requests">
          {FILTERS.map((f) => {
            const active = status === f.key;
            return (
              <button
                key={f.key}
                type="button"
                className={`inbox-segment${active ? ' is-active' : ''}`}
                aria-pressed={active}
                onClick={() => setStatus(f.key)}
              >
                {f.label}
                {f.key === 'open' && todo > 0 && (
                  <span className="inbox-segment-count">{todo}</span>
                )}
              </button>
            );
          })}
        </div>
      </div>
      <div className="inbox-content">
        {/* refreshCounts after every complete/delete keeps the nav badges and
            the To Do counter in step with the list */}
        {kind === 'songs' ? (
          <SongRequestList status={status} onChanged={refreshCounts} today={today} />
        ) : (
          <ContactRequestList status={status} onChanged={refreshCounts} today={today} />
        )}
      </div>
    </div>
  );
};

export default RequestsPanel;
